module.exports = __webpack_public_path__ + "static/media/IconTemplates_-13.a9668415.svg";